import styled from "styled-components"; // TODO: Deprecate

var ButtonBase =
/*#__PURE__*/
styled.button.withConfig({
  displayName: "ButtonBase"
})(["background:", ";color:", ";&:hover,&:focus,&:active{background:", ";}&:disabled{background:", ";}border:0;border-radius:4px;cursor:pointer;display:block;font-weight:bold;line-height:1;letter-spacing:0.03em;margin:20px auto;padding:14px 10px;text-align:center;text-decoration:none;text-transform:uppercase;"], function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      theme = _ref.theme;
  return backgroundColor || theme.buttonBackgroundColor || "#098509";
}, function (_ref2) {
  var textColor = _ref2.textColor,
      theme = _ref2.theme;
  return textColor || theme.buttonTextColor || "#fff";
}, function (_ref3) {
  var activeBackgroundColor = _ref3.activeBackgroundColor,
      theme = _ref3.theme;
  return activeBackgroundColor || theme.buttonActiveBackgroundColor || "#076407";
}, function (_ref4) {
  var disabledBackgroundColor = _ref4.disabledBackgroundColor,
      theme = _ref4.theme;
  return disabledBackgroundColor || theme.buttonDisabledBackgroundColor || "#c8d2e6";
}); // TODO: Deprecate

export var ButtonCapsule =
/*#__PURE__*/
styled(ButtonBase).withConfig({
  displayName: "ButtonCapsule"
})(["width:100%;background:#00e1ff;border-radius:20px;color:#002272;&:hover,&:focus,&:active{background:#00e1ff;}@media (min-width:651px){border-radius:28px;font-size:18px;line-height:27px;max-width:430px;}"]); // TODO: Deprecate

export var ButtonLarge =
/*#__PURE__*/
styled(ButtonBase).withConfig({
  displayName: "ButtonLarge"
})(["line-height:18px;max-width:280px;width:100%;@media (min-width:651px){line-height:27px;max-width:430px;}"]); // TODO: Deprecate

export var ButtonSmall =
/*#__PURE__*/
styled.button.withConfig({
  displayName: "ButtonSmall"
})(["align-items:center;background:#00e1ff;border:0;border-radius:18px;color:#141e37;cursor:pointer;display:inline-flex;font-size:14px;font-weight:700;height:36px;outline-offset:4px;padding:0 15px;text-decoration:none;&:link,&:active,&:visited{color:#141e37;}&:hover,&:active{background:#80f0ff;}&:active{box-shadow:0 0 0 4px rgba(0,225,255,0.5);}"]); // TODO: Deprecate

export var ButtonSmallOld =
/*#__PURE__*/
styled(ButtonBase).withConfig({
  displayName: "ButtonSmallOld"
})(["width:120px;margin:15px;display:inline-block;"]);
var backgroundColor = {
  blue: "#015b9d",
  yellow: "#fcb813"
};
var fontColor = {
  blue: "#ffffff",
  yellow: "#002272"
}; // TODO: Deprecate

export var OldButton =
/*#__PURE__*/
styled.button.withConfig({
  displayName: "OldButton"
})(["font-size:inherit;text-align:center;margin:18px auto;display:block;transition:background 0.25s ease;line-height:1;letter-spacing:0.03em;padding:14px 10px;width:200px;color:", ";background:", ";border:0;border-radius:", "px;"], function (_ref5) {
  var color = _ref5.color;
  return fontColor[color] || "#002272";
}, function (_ref6) {
  var color = _ref6.color,
      toggleon = _ref6.toggleon;
  return toggleon ? "#ffffff" : backgroundColor[color] || "#ffffff";
}, function (_ref7) {
  var radius = _ref7.radius;
  return radius === "large" ? 10 : 5;
});